/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    declare var Snap: any;

    export class WorkflowDrawingService {

        private logType: string = "WorkflowDrawingService";

        public static CalculateStarPoints(centerCoordinate: models.Coordinate, arms: number, outerRadius: number, innerRadius: number): Array<number> {
            var results: Array<number> = [];

            var angle = Math.PI / arms;

            for (var i = 0; i <= 2 * arms; i++) {
                // Use outer or inner radius depending on what iteration we are in.
                var r = (i & 1) == 0 ? outerRadius : innerRadius;

                var currX = centerCoordinate.x + Math.cos(i * angle) * r;
                var currY = centerCoordinate.y + Math.sin(i * angle) * r;

                results.push(currX);
                results.push(currY);
            }

            return results;
        }

        constructor() {
        }

        public changeViewBoxSizeAndOffset(
            paper: Snap.Paper,
            xOffset: number,
            yOffset: number,
            width: number,
            height: number): void
        {
            if (!paper) return;
            paper.attr({ viewBox: xOffset + ' ' + yOffset + ' ' + width + ' ' + height });
        }

        public drawModel(workflowDrawingInstance: models.WorkflowDrawingInstance, initialBlock: models.IWorkflowBlock): models.Coordinate {

            if (!initialBlock) return;
            
            var currentBlock: models.IWorkflowBlock;
            var previousBlock: models.IWorkflowBlock;

            workflowDrawingInstance.blockLocations = new Array<models.WorkflowBlockLocation>();
            workflowDrawingInstance.lineLocations = new Array<models.Coordinate>();
            workflowDrawingInstance.inBetweenDropZones = new Array<Snap.Element>();
            var currentYesBranchBlockLocations = new Array<models.WorkflowItemAwaitingDrawing>();

            // start with initial state and work through the relationships
            var initialCoordinate = new models.Coordinate(0, 0);
            var workflowBlockGroup = initialBlock.draw(workflowDrawingInstance.paper, initialCoordinate);
            initialBlock.addTitleToGroup(workflowBlockGroup);
            workflowBlockGroup.attr({ "data-class": "workflowBlockGroup" });

            workflowDrawingInstance.blockLocations.push(new models.WorkflowBlockLocation(initialBlock, initialCoordinate));
            
            var previousPosition = initialCoordinate;
            previousBlock = initialBlock;
            var currentlyDrawingNoBranch = false;
            var currentlyDrawingNonZeroIndexMultipleOutputToBlock = false;

            var todoDownDirectionBranchStack: Array<models.PendingWorkflowItem> = new Array<models.PendingWorkflowItem>();
            var todoRightDirectionBranchStack: Array<models.PendingWorkflowItem> = new Array<models.PendingWorkflowItem>();
            var currentGotoId = models.WorkflowBlockManager.initialGotoId;
            
            // now continue on with the next block
            if (initialBlock.toBlocks[0]) {
                currentBlock = initialBlock.toBlocks[0];
                for (let i = initialBlock.toBlocks.length - 1; i > 0 ; i--) {
                    todoRightDirectionBranchStack.push(new models.PendingWorkflowItem(initialBlock, initialBlock.toBlocks[i]));
                }
            }

            while (currentBlock) {
                // Get the draw coordinates
                var newCoordinate = this.calculateDrawCoordinates(
                    workflowDrawingInstance,
                    currentBlock,
                    previousPosition,
                    currentlyDrawingNoBranch,
                    currentlyDrawingNonZeroIndexMultipleOutputToBlock,
                    currentYesBranchBlockLocations);

                var pending = new models.PendingWorkflowItem(previousBlock, currentBlock);
                WarsLogger.logDebug("Adding " + currentBlock.typeName + " to branch at (" + newCoordinate.x + ", " + newCoordinate.y + ")", "WorkflowDrawingService");
                currentYesBranchBlockLocations.push(new models.WorkflowItemAwaitingDrawing(pending, newCoordinate));

                var newGotoCoordinate: models.Coordinate;

                if (currentBlock.type !== Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                    // Add yes and no blocks to todo stacks
                    if (currentBlock.toBlocks[0]) {
                        if (this.doesWorkflowBlockAlreadyExist(
                            workflowDrawingInstance,
                            currentBlock.toBlocks[0],
                            todoDownDirectionBranchStack.concat(todoRightDirectionBranchStack),
                            currentYesBranchBlockLocations))
                        {
                            let newGotoWorkflowBlock = new models.GotoWorkflowBlock((currentGotoId++).toString(), currentBlock.toBlocks[0] ? currentBlock.toBlocks[0].label : "Go To");
                            newGotoWorkflowBlock.toBlock = currentBlock.toBlocks[0];
                            newGotoWorkflowBlock.setDrawingInstance(workflowDrawingInstance);
                            currentBlock.toBlocks[0] = newGotoWorkflowBlock;
                        }
                        todoDownDirectionBranchStack.push(new models.PendingWorkflowItem(currentBlock, currentBlock.toBlocks[0]));
                    }
                    for (let i = currentBlock.toBlocks.length - 1; i > 0; i--) {
                        if (currentBlock.toBlocks[i]) {
                            if (this.doesWorkflowBlockAlreadyExist(
                                workflowDrawingInstance,
                                currentBlock.toBlocks[i],
                                todoDownDirectionBranchStack.concat(todoRightDirectionBranchStack),
                                currentYesBranchBlockLocations))
                            {
                                let newGotoWorkflowBlock = new models.GotoWorkflowBlock((currentGotoId++).toString(), currentBlock.toBlocks[i] ? currentBlock.toBlocks[i].label : "Go To");
                                newGotoWorkflowBlock.toBlock = currentBlock.toBlocks[i];
                                newGotoWorkflowBlock.setDrawingInstance(workflowDrawingInstance);
                                currentBlock.toBlocks[i] = newGotoWorkflowBlock;
                            }
                            todoRightDirectionBranchStack.push(new models.PendingWorkflowItem(currentBlock, currentBlock.toBlocks[i]));
                        }
                    }
                }

                

                // Set up next current block by taking off the end of the array - draw yes branches first
                if (todoDownDirectionBranchStack.length > 0) {
                    let todoItem = todoDownDirectionBranchStack.pop();
                    currentBlock = todoItem.pendingWorkflowBlock;
                    currentlyDrawingNoBranch = false;
                    currentlyDrawingNonZeroIndexMultipleOutputToBlock = false;
                    previousBlock = todoItem.sourceWorkflowBlock;
                    previousPosition = this.getPositionOfPreviouslyProcessedWorkflowBlock(workflowDrawingInstance, currentYesBranchBlockLocations, previousBlock.id);
                }
                else if (todoRightDirectionBranchStack.length > 0) {
                    let todoItem = todoRightDirectionBranchStack.pop();
                    currentBlock = todoItem.pendingWorkflowBlock;
                    if (todoItem.sourceIsMultipleOutputAndPendingIsNotFirstToBlock()) {
                        currentlyDrawingNoBranch = false;
                        currentlyDrawingNonZeroIndexMultipleOutputToBlock = true;
                    } else {
                        currentlyDrawingNoBranch = true;
                        currentlyDrawingNonZeroIndexMultipleOutputToBlock = false;
                    }
                    previousBlock = todoItem.sourceWorkflowBlock;
                    previousPosition = this.getPositionOfPreviouslyProcessedWorkflowBlock(workflowDrawingInstance, currentYesBranchBlockLocations, previousBlock.id);

                    this.drawBranch(workflowDrawingInstance, currentYesBranchBlockLocations);
                    currentYesBranchBlockLocations = [];
                }
                else {
                    currentBlock = undefined;
                    this.drawBranch(workflowDrawingInstance, currentYesBranchBlockLocations);
                    currentYesBranchBlockLocations = [];
                }
            }

            for (let i = 0; i < workflowDrawingInstance.blockLocations.length; i++) {
                workflowDrawingInstance.blockLocations[i].workflowBlock.entireWorkflowDrawComplete();
            }
            for (let i = 0; i < workflowDrawingInstance.blockLocations.length; i++) {
                workflowDrawingInstance.blockLocations[i].workflowBlock.entireWorkflowDrawComplete2();
            } 
            
            // Using a set timeout with 2 here b/c I have set timeouts inside the entireWorkflowDrawComplete() calls above that fit the title in the shape based on rendered size.
            setTimeout(() => workflowDrawingInstance.paper.attr({ opacity: 1 }), 2);

            var maxXCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).max(i => i.coordinate.x);
            var maxYCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).max(i => i.coordinate.y);

            return new models.Coordinate(maxXCoordinate, maxYCoordinate);
        }

        private calculateDrawCoordinates(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            currentBlock: models.IWorkflowBlock,
            previousPosition: models.Coordinate,
            currentlyDrawingNoBranch: boolean,
            currentlyDrawingNonZeroIndexMultipleOutputToBlock: boolean,
            currentYesBranchBlockLocations: models.WorkflowItemAwaitingDrawing[]): warsApp.models.Coordinate
        {
            // Derive new coordinate based on whether we are drawing a yes or no branch
            var newCoordinate: warsApp.models.Coordinate;

            var onlyCheckDrawingSpot = currentBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.None ||
                currentBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.Goto;

            if (currentlyDrawingNoBranch) {
                newCoordinate = new models.Coordinate(previousPosition.x + 1, previousPosition.y)
                let spaceIsNotAvailable = false;
                do {
                    if (onlyCheckDrawingSpot) {
                        spaceIsNotAvailable = this.isGridSpotOccupied(workflowDrawingInstance, newCoordinate);
                    } else {
                        spaceIsNotAvailable = this.isSpecifiedSpotOrSpotBelowOccupied(workflowDrawingInstance, newCoordinate);
                    }
                    if (spaceIsNotAvailable) {
                        newCoordinate.x = newCoordinate.x + 1;
                    }
                } while (spaceIsNotAvailable)

            }
            else if (currentlyDrawingNonZeroIndexMultipleOutputToBlock) {
                newCoordinate = new models.Coordinate(previousPosition.x + 1, previousPosition.y + 1)
                let spaceIsNotAvailable = false;
                do {
                    if (onlyCheckDrawingSpot) {
                        spaceIsNotAvailable = this.isGridSpotOccupied(workflowDrawingInstance, newCoordinate);
                    } else {
                        spaceIsNotAvailable = this.isSpecifiedSpotOrSpotBelowOccupied(workflowDrawingInstance, newCoordinate);
                    }
                    if (spaceIsNotAvailable) {
                        newCoordinate.x = newCoordinate.x + 1;
                    }
                } while (spaceIsNotAvailable)
            }
            else {
                newCoordinate = new warsApp.models.Coordinate(previousPosition.x, previousPosition.y + 1);
                let spaceIsNotAvailable = false;
                do {
                    if (onlyCheckDrawingSpot) {
                        spaceIsNotAvailable = this.isGridSpotOccupied(workflowDrawingInstance, newCoordinate);
                    } else {
                        spaceIsNotAvailable = this.isSpecifiedSpotOrSpotBelowOccupied(workflowDrawingInstance, newCoordinate);
                    }

                    if (spaceIsNotAvailable) {
                        this.shiftYesBranchToTheRightOne(currentYesBranchBlockLocations);
                        newCoordinate.x = newCoordinate.x + 1;
                    }
                } while (spaceIsNotAvailable)
            }
            return newCoordinate;
        }

        // Private Helper Methods
        // ===================================================================================================================
        private reDraw(workflowDrawingInstance: models.WorkflowDrawingInstance) : void {
            workflowDrawingInstance.reDraw();
        }

        private isGridSpotOccupied(workflowDrawingInstance: models.WorkflowDrawingInstance, gridCoordinate: models.Coordinate): boolean {
            var isBlockAtSpecifiedLocation = Enumerable.from(workflowDrawingInstance.blockLocations).any(i => i.coordinate.equals(gridCoordinate));
            var isLineAtSpecifiedLocation = Enumerable.from(workflowDrawingInstance.lineLocations).any(i => i.equals(gridCoordinate));
            var spotIsOccupied = isBlockAtSpecifiedLocation || isLineAtSpecifiedLocation;
            if (spotIsOccupied) {
                var endPartOfMsg = isBlockAtSpecifiedLocation ? " block." : " line.";
                WarsLogger.logDebug('The current spot is occupied: (' + gridCoordinate.x + ', ' + gridCoordinate.y + ") by a" + endPartOfMsg, this.logType);

            }
            return spotIsOccupied;
        }

        private isGridSpotBelowOccupied(workflowDrawingInstance: models.WorkflowDrawingInstance, gridCoordinate: models.Coordinate): boolean {
            var belowCoordinate = new models.Coordinate(gridCoordinate.x, gridCoordinate.y + 1);
            return this.isGridSpotOccupied(workflowDrawingInstance, belowCoordinate);
        }

        private isSpecifiedSpotOrSpotBelowOccupied(workflowDrawingInstance: models.WorkflowDrawingInstance, gridCoordinate: models.Coordinate): boolean {
            return this.isGridSpotOccupied(workflowDrawingInstance, gridCoordinate) || this.isGridSpotBelowOccupied(workflowDrawingInstance,gridCoordinate);
        }

        private shiftYesBranchToTheRightOne(currentYesBranchBlockLocations: Array<models.WorkflowItemAwaitingDrawing>): void {
            WarsLogger.logDebug("Shifting branch to the right by one.", this.logType);
            for (var i = 0; i < currentYesBranchBlockLocations.length; i++) {
                var coordinate = currentYesBranchBlockLocations[i].coordinate;
                currentYesBranchBlockLocations[i].coordinate = new models.Coordinate(coordinate.x + 1, coordinate.y);
                var typeName = currentYesBranchBlockLocations[i].pendingWorkflowItem.pendingWorkflowBlock.typeName
                WarsLogger.logDebug("Workflow Block of type: " + typeName + " is being moved 1 to the right to (" + (coordinate.x + 1) + ", " + coordinate.y + ")", this.logType);
            }
        }

        private getPositionOfPreviouslyProcessedWorkflowBlock(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            currentYesBranchBlockLocations: Array<models.WorkflowItemAwaitingDrawing>,
            previousBlockId: string): models.Coordinate
        {
            var previousBlockLocation = Enumerable.from(workflowDrawingInstance.blockLocations).singleOrDefault(i => i.workflowBlock.id === previousBlockId);
            if (previousBlockLocation) return previousBlockLocation.coordinate;
            var inWorkBlockLocation = Enumerable.from(currentYesBranchBlockLocations).singleOrDefault(i => i.pendingWorkflowItem.pendingWorkflowBlock.id == previousBlockId);
            if (inWorkBlockLocation) return inWorkBlockLocation.coordinate;
            return undefined;
        }

        private drawBranch(workflowDrawingInstance: models.WorkflowDrawingInstance, currentYesBranchBlockLocations: Array<models.WorkflowItemAwaitingDrawing>): void {
            WarsLogger.logDebug("Drawing workflow branch for " + currentYesBranchBlockLocations.length + " items.", this.logType);
            var workflowBlockGroup: Snap.Element;
            for (var i = 0; i < currentYesBranchBlockLocations.length; i++) {
                var currentBlock = currentYesBranchBlockLocations[i].pendingWorkflowItem.pendingWorkflowBlock;
                var coordinate = currentYesBranchBlockLocations[i].coordinate;
                // Draw the block
                workflowBlockGroup = currentBlock.draw(workflowDrawingInstance.paper, coordinate);
                currentBlock.addTitleToGroup(workflowBlockGroup);
                workflowBlockGroup.attr({ "data-class": "workflowBlockGroup" });

                WarsLogger.logDebug("Drawing workflow block for " + currentBlock.typeName + " at " + coordinate.x + ", " + coordinate.y, this.logType);
                workflowDrawingInstance.blockLocations.push(new models.WorkflowBlockLocation(currentBlock, coordinate));

                // Draw the arrow
                this.drawArrow(workflowDrawingInstance, currentYesBranchBlockLocations[i].pendingWorkflowItem.sourceWorkflowBlock, currentBlock);
                
                // Draw the in between drop zone
                var currentIndex = workflowDrawingInstance.inBetweenDropZones.length;

                var dropZone = this.drawInBetweenDropZone(
                    workflowDrawingInstance,
                    currentYesBranchBlockLocations[i].pendingWorkflowItem.sourceWorkflowBlock,
                    currentBlock,
                    currentIndex);

                if (dropZone !== undefined) workflowDrawingInstance.inBetweenDropZones.push(dropZone);
            }
        }

        private drawArrow(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            fromWorkflowBlock: models.IWorkflowBlock,
            toWorkflowBlock: models.IWorkflowBlock): void
        {
            var fromCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === fromWorkflowBlock.id).coordinate;
            var toCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === toWorkflowBlock.id).coordinate;

            var blockWidth = fromWorkflowBlock.blockWidth;
            var blockHeight = fromWorkflowBlock.blockHeight;

            var element: Snap.Element;

            if (fromCoordinate.x === toCoordinate.x) {
                // Simple down arrow
                var xDeparturePoint = (fromCoordinate.x * blockWidth) + (fromWorkflowBlock.blockWidth / 2);
                var yDeparturePoint = ((fromCoordinate.y + 1) * blockHeight) - fromWorkflowBlock.getBottomPadding();

                var xArrivalPoint = (toCoordinate.x * blockWidth) + (blockWidth / 2);
                var yArrivalPoint = (toCoordinate.y * blockHeight) + toWorkflowBlock.getTopPadding() - 1;

                element = workflowDrawingInstance.paper.polyline([xDeparturePoint, yDeparturePoint, xArrivalPoint, yArrivalPoint]);
                element.attr(workflowDrawingInstance.settings.lineAttributes);

                if (fromWorkflowBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                    var yesLabel = workflowDrawingInstance.paper.text(xDeparturePoint + 5, yDeparturePoint + 10, 'YES');
                    yesLabel.attr({ class: 'arrow-label' });
                    workflowDrawingInstance.lines.append(yesLabel);
                }
                
                this.drawArrowTip(workflowDrawingInstance, new warsApp.models.Coordinate(xArrivalPoint, yArrivalPoint), 0);
            } else if (fromCoordinate.y === toCoordinate.y) {
                // Simple to the right arrow
                var xDeparturePoint = ((fromCoordinate.x + 1) * blockWidth) - fromWorkflowBlock.getRightPadding();
                var yDeparturePoint = (fromCoordinate.y * blockHeight) + (blockHeight / 2);

                var xArrivalPoint = (toCoordinate.x * blockWidth) + toWorkflowBlock.getLeftPadding() - 1;
                var yArrivalPoint = (toCoordinate.y * blockHeight) + (blockHeight / 2);

                element = workflowDrawingInstance.paper.polyline([xDeparturePoint, yDeparturePoint, xArrivalPoint, yArrivalPoint]);
                element.attr(workflowDrawingInstance.settings.lineAttributes);

                if (fromWorkflowBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                    var noLabel = workflowDrawingInstance.paper.text(xDeparturePoint + 5, yDeparturePoint - 5, 'NO');
                    noLabel.attr({ class: 'arrow-label' });
                    workflowDrawingInstance.lines.append(noLabel);
                }

                this.drawArrowTip(workflowDrawingInstance, new warsApp.models.Coordinate(xArrivalPoint, yArrivalPoint), 270);
            }
            else {
                // Must be arrow to the right and down - always departs in the middle of another line (the straight down line).
                var xDeparturePoint = (fromCoordinate.x * blockWidth) + (blockWidth/2);
                var yDeparturePoint = (fromCoordinate.y + 1) * blockHeight - 10;

                var xMidPoint = (toCoordinate.x * blockWidth) + (blockWidth / 2);
                var yMidPoint = yDeparturePoint;

                var xArrivalPoint = xMidPoint;
                var yArrivalPoint = (toCoordinate.y * blockHeight) + toWorkflowBlock.getTopPadding() ;

                element = workflowDrawingInstance.paper.polyline([xDeparturePoint, yDeparturePoint, xMidPoint, yMidPoint, xArrivalPoint, yArrivalPoint]);
                element.attr(workflowDrawingInstance.settings.lineAttributes);

                this.drawArrowTip(workflowDrawingInstance, new warsApp.models.Coordinate(xArrivalPoint, yArrivalPoint), 0);
            }

            // This ensures the lines are behind other elements.
            workflowDrawingInstance.lines.append(element);

            for (var i = fromCoordinate.x + 1; i < toCoordinate.x; i++) {
                WarsLogger.logDebug("Adding a new line location: " + i + ", " + toCoordinate.y, this.logType);
                workflowDrawingInstance.lineLocations.push(new models.Coordinate(i, toCoordinate.y));
            }
        }

        /// 0 rotation is pointing down, 270 is pointing right
        private drawArrowTip(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            originVertice: models.Coordinate,
            rotation: number,
            isFeedbackLoop?: boolean,
            isToggleEnabled?: boolean): Snap.Element
        {
            var xFirstVertice: number;
            var yFirstVertice: number;

            var lineThicknessOffset = isFeedbackLoop ? 4.5 : 0.75;
            var smallOffset = isFeedbackLoop ? 10 : 5;
            var largeOffset = isFeedbackLoop ? 20 : 10;

            // Account for widths in lines themselves
            if (rotation === 0) {
                xFirstVertice = originVertice.x;
                yFirstVertice = originVertice.y + lineThicknessOffset + 1;
            }
            else if (rotation === 90) {
                xFirstVertice = originVertice.x - lineThicknessOffset - 1;
                yFirstVertice = originVertice.y;
            }
            else if (rotation === 270) {
                xFirstVertice = originVertice.x + lineThicknessOffset + 1;
                yFirstVertice = originVertice.y;
            }

            var xSecondVertice = xFirstVertice + smallOffset;
            var ySecondVertice = yFirstVertice - largeOffset;

            var xThridVertice = xFirstVertice - smallOffset;
            var ySecondVertice = yFirstVertice - largeOffset;

            var verticies = new Array<number>();

            verticies.push(xFirstVertice);
            verticies.push(yFirstVertice);

            verticies.push(xSecondVertice);
            verticies.push(ySecondVertice);

            verticies.push(xThridVertice);
            verticies.push(ySecondVertice);

            verticies.push(xFirstVertice);
            verticies.push(yFirstVertice);

            var arrowTip = workflowDrawingInstance.paper.polyline(verticies);
            if (isFeedbackLoop) {
                if (isToggleEnabled) {
                    arrowTip.attr(workflowDrawingInstance.settings.toggleEnabledfeedbackArrowAttributes);
                } else {
                    arrowTip.attr(workflowDrawingInstance.settings.feedbackArrowAttributes);
                }
            } else {
                arrowTip.attr(workflowDrawingInstance.settings.arrowAttributes);
            }

            // Now apply rotation
            var matrix = new Snap.Matrix();
            matrix.rotate(rotation, xFirstVertice, yFirstVertice);
            arrowTip.transform(matrix);

            // This ensures the arrow tips are behind other elements.
            if (isFeedbackLoop) {
                workflowDrawingInstance.feedbackLines.append(arrowTip);
            } else {
                workflowDrawingInstance.lines.append(arrowTip);
            }

            return arrowTip;
        }

        private drawInBetweenDropZone(workflowDrawingInstance: models.WorkflowDrawingInstance,
            fromWorkflowBlock: models.IWorkflowBlock,
            toWorkflowBlock: models.IWorkflowBlock,
            index: number): Snap.Element
        {
            if (fromWorkflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.State) return undefined;
            if (fromWorkflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.Goto) return undefined;
            if (toWorkflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.DropZone) return undefined;

            var fromCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === fromWorkflowBlock.id).coordinate;
            var toCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === toWorkflowBlock.id).coordinate;

            var blockWidth = fromWorkflowBlock.blockWidth;
            var blockHeight = fromWorkflowBlock.blockHeight;

            var dropZone: Snap.Element;
            var x: number;
            var y: number;
            var inBetweenWidth = 10;
            var attributes = {
                "class": "in-between-drop-zone",
                "data-class": "in-between-drop-zone",
                "data-from-id": fromWorkflowBlock.id,
                "data-to-id": toWorkflowBlock.id,
                "data-index": index
            }

            if (fromCoordinate.x === toCoordinate.x) {
                // Simple down arrow
                x = (fromCoordinate.x * blockWidth) + inBetweenWidth;
                y = (toCoordinate.y * blockHeight) - inBetweenWidth;

                dropZone = workflowDrawingInstance.paper.rect(x, y, blockWidth - (2 * inBetweenWidth), 2 * inBetweenWidth);
                dropZone.attr(attributes);
            } else if (fromCoordinate.y === toCoordinate.y) {
                // Simple to the right arrow
                x = (toCoordinate.x * blockWidth) - inBetweenWidth;
                y = (toCoordinate.y * blockHeight) + inBetweenWidth;

                dropZone = workflowDrawingInstance.paper.rect(x, y, 2 * inBetweenWidth, blockHeight - (2 * inBetweenWidth));
                dropZone.attr(attributes);
            } else {
                // Must be arrow to the right and down - always departs in the middle of another line (the straight down line).
                x = (toCoordinate.x * blockWidth) + inBetweenWidth;
                y = (toCoordinate.y * blockHeight) - inBetweenWidth;

                dropZone = workflowDrawingInstance.paper.rect(x, y, blockWidth - (2 * inBetweenWidth), 2 * inBetweenWidth);
                dropZone.attr(attributes);
            }
            return dropZone;
        }

        public drawFeedbackArrow(workflowDrawingInstance: models.WorkflowDrawingInstance,
            fromWorkflowBlock: models.IWorkflowBlock,
            toWorkflowBlock: models.IWorkflowBlock,
            toggleEnabled: boolean): Snap.Element {

            if (!toWorkflowBlock) return;

            var line: Snap.Element;
            var arrowTip: Snap.Element;

            var shortenDistanceToAccountForLineThickness = 4;
            var verticalOffsetFromGridline = 5;

            var fromCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === fromWorkflowBlock.id).coordinate;
            var toCoordinate = Enumerable.from(workflowDrawingInstance.blockLocations).single(i => i.workflowBlock.id === toWorkflowBlock.id).coordinate;

            var blockWidth = fromWorkflowBlock.blockWidth;
            var blockHeight = fromWorkflowBlock.blockHeight;

            var x : number;
            var y: number;
            var arrowRotation: number;

            var lineCoordinates: Array<number> = [];

            if (fromCoordinate.x <= toCoordinate.x) {
                // Draw arrow to the right
                x = ((fromCoordinate.x + 1) * blockWidth) - fromWorkflowBlock.getRightPadding();
                y = (fromCoordinate.y * blockHeight) + (blockHeight / 2);
                lineCoordinates.push(x);
                lineCoordinates.push(y);

                if (fromCoordinate.y == toCoordinate.y) {
                    if (this.areAnyWorkflowBlockBetweenTwoCoordinates(workflowDrawingInstance, fromCoordinate, toCoordinate)) {
                        var originY = y;
                        var raisedY = y = (fromCoordinate.y * blockHeight);

                        var raiseX = (fromCoordinate.x + 1) * blockWidth;
                        var dropX = (toCoordinate.x) * blockWidth;
                        var destinationX = (toCoordinate.x) * blockWidth + toWorkflowBlock.getLeftPadding();

                        lineCoordinates.push(raiseX);
                        lineCoordinates.push(originY);

                        lineCoordinates.push(raiseX);
                        lineCoordinates.push(raisedY);

                        lineCoordinates.push(dropX);
                        lineCoordinates.push(raisedY);

                        lineCoordinates.push(dropX);
                        lineCoordinates.push(originY);

                        lineCoordinates.push(destinationX);
                        lineCoordinates.push(originY);

                        // Reset so arrow head is in correct place
                        x = destinationX;
                        y = originY;
                    } else {
                        // straight to the right X spots   
                        x = (toCoordinate.x * blockWidth) + toWorkflowBlock.getLeftPadding();
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);
                    }
                    arrowRotation = 270;
                }
                else {
                    x = x + fromWorkflowBlock.getRightPadding(); 

                    lineCoordinates.push(x);
                    lineCoordinates.push(y);
                    
                    y = (toCoordinate.y * blockHeight) + (blockHeight / 2);
                   
                    lineCoordinates.push(x);
                    lineCoordinates.push(y);

                    var endsGoingLeft = fromCoordinate.x == toCoordinate.x;
                    if (endsGoingLeft) {
                        x = x - toWorkflowBlock.getRightPadding() + verticalOffsetFromGridline;
                        arrowRotation = 90;
                    } else {
                        var numberOfSkippedXCoordinates = toCoordinate.x - fromCoordinate.x - 1;
                        var additionalXOffset = numberOfSkippedXCoordinates * blockWidth;
                        x = x + toWorkflowBlock.getLeftPadding() + additionalXOffset - verticalOffsetFromGridline;
                        arrowRotation = 270;
                    }

                    lineCoordinates.push(x);
                    lineCoordinates.push(y);
                }
            } else {
                // Draw arrow to the left
                arrowRotation = 90;

                var originX = (fromCoordinate.x * blockWidth) + fromWorkflowBlock.getLeftPadding();
                x = originX;
                var originY = (fromCoordinate.y * blockHeight) + (blockHeight / 2);
                y = originY;
                
                lineCoordinates.push(originX);
                lineCoordinates.push(originY);

                if (fromCoordinate.y == toCoordinate.y) {
                    if (this.areAnyWorkflowBlockBetweenTwoCoordinates(workflowDrawingInstance, fromCoordinate, toCoordinate)) {
                        var raisedY = (fromCoordinate.y * blockHeight);

                        var raiseX = (fromCoordinate.x) * blockWidth;
                        var dropX = (toCoordinate.x + 1) * blockWidth;
                        var destinationX = (toCoordinate.x + 1) * blockWidth - toWorkflowBlock.getRightPadding();

                        lineCoordinates.push(raiseX);
                        lineCoordinates.push(originY);

                        lineCoordinates.push(raiseX);
                        lineCoordinates.push(raisedY);

                        lineCoordinates.push(dropX);
                        lineCoordinates.push(raisedY);
                        
                        lineCoordinates.push(dropX);
                        lineCoordinates.push(originY);

                        lineCoordinates.push(destinationX);
                        lineCoordinates.push(originY);

                        // Reset so arrow head is in correct place
                        x = destinationX;
                        y = originY;
                    }
                    else {
                        // straight to the left X spots   
                        x = ((toCoordinate.x + 1) * blockWidth) - toWorkflowBlock.getRightPadding() + shortenDistanceToAccountForLineThickness;
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);
                    }
                } else {
                    var goingUp = toCoordinate.y < fromCoordinate.y;
                    
                    var straightAcrossToLeftFromOrigin = new models.Coordinate(toCoordinate.x, fromCoordinate.y);
                    var straightUpOrDownFromOrigin = new models.Coordinate(fromCoordinate.x, toCoordinate.y);
                    var raiseOrLowerCoordinateOffset = goingUp ? 0 : 1;

                    if (!this.areAnyWorkflowBlockBetweenTwoCoordinates(workflowDrawingInstance, fromCoordinate, straightAcrossToLeftFromOrigin)) {
                        x = ((straightAcrossToLeftFromOrigin.x + 1) * blockWidth);
                        lineCoordinates.push(x);
                        lineCoordinates.push(originY);

                        y = toCoordinate.y * blockHeight + (blockHeight / 2);
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);

                        x = ((straightAcrossToLeftFromOrigin.x + 1) * blockWidth) - toWorkflowBlock.getRightPadding() + shortenDistanceToAccountForLineThickness;
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);
                    } else if (!this.areAnyWorkflowBlockBetweenTwoCoordinates(workflowDrawingInstance, straightUpOrDownFromOrigin, toCoordinate)) {
                        x = x - fromWorkflowBlock.getLeftPadding();
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);

                        y = toCoordinate.y * blockHeight + (blockHeight / 2);
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);

                        x = ((toCoordinate.x + 1) * blockWidth) - toWorkflowBlock.getRightPadding() + shortenDistanceToAccountForLineThickness; 
                        lineCoordinates.push(x);
                        lineCoordinates.push(y);
                    } else {
                        var firstRaiseX = fromCoordinate.x * blockWidth;
                        var secondRaiseX = (toCoordinate.x + 1) * blockWidth;
                        var destinationX = secondRaiseX - toWorkflowBlock.getRightPadding() + shortenDistanceToAccountForLineThickness;

                        var firstRaiseY = ((fromCoordinate.y + raiseOrLowerCoordinateOffset) * blockHeight) - verticalOffsetFromGridline;
                        var destinationY = (toCoordinate.y * blockHeight) + (blockHeight / 2);

                        lineCoordinates.push(firstRaiseX);
                        lineCoordinates.push(originY);

                        lineCoordinates.push(firstRaiseX);
                        lineCoordinates.push(firstRaiseY);

                        lineCoordinates.push(secondRaiseX);
                        lineCoordinates.push(firstRaiseY);

                        lineCoordinates.push(secondRaiseX);
                        lineCoordinates.push(destinationY);

                        lineCoordinates.push(destinationX);
                        lineCoordinates.push(destinationY);

                        // Reset so arrow head is in correct place
                        x = destinationX;
                        y = destinationY;
                    }
                }
            }

            line = workflowDrawingInstance.paper.polyline(lineCoordinates);
            if (toggleEnabled) {
                line.attr(workflowDrawingInstance.settings.toggleEnabledfeedbackLineAttributes);
            } else {
                line.attr(workflowDrawingInstance.settings.feedbackLineAttributes);
            }

            var arrowCoordinate = new models.Coordinate(x, y);
            var tip = this.drawArrowTip(workflowDrawingInstance, arrowCoordinate, arrowRotation, true, toggleEnabled);
            var group = workflowDrawingInstance.paper.group(line, tip);

            // This ensures the lines are behind other elements and thus do not mess up the hover targets.
            workflowDrawingInstance.feedbackLines.append(group);

            return group;
        }

        private areAnyWorkflowBlockBetweenTwoCoordinates(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            startCoordinate: models.Coordinate,
            endCoordinate: models.Coordinate): boolean
        {
            var collision = false;
            var blockCoordinates = Enumerable.from(workflowDrawingInstance.blockLocations).select(i => i.coordinate).toArray();

            if (startCoordinate.x === endCoordinate.x) {
                var minY = Math.min(startCoordinate.y, endCoordinate.y);
                var maxY = Math.max(startCoordinate.y, endCoordinate.y);
                
                for (var yIndex = minY + 1; yIndex < maxY; yIndex++) {
                    var testCoordinate = new models.Coordinate(startCoordinate.x, yIndex);
                    if (Enumerable.from(blockCoordinates).any(i => i.equals(testCoordinate))) {
                        collision = true;
                        break;
                    }
                }
                return collision;
            }
            else if (startCoordinate.y === endCoordinate.y) {
                var minX = Math.min(startCoordinate.x, endCoordinate.x);
                var maxX = Math.max(startCoordinate.x, endCoordinate.x);
                for (var xIndex = minX + 1; xIndex < maxX; xIndex++) {
                    var testCoordinate = new models.Coordinate(xIndex, startCoordinate.y);
                    if (Enumerable.from(blockCoordinates).any(i => i.equals(testCoordinate))) {
                        collision = true;
                        break;
                    }
                }
                return collision;
            }
            else {
                // Only return false if start and end are either straight across or straight up and down from each other.
                return true;
            }
        }

        private doesWorkflowBlockAlreadyExist(
            workflowDrawingInstance: models.WorkflowDrawingInstance,
            workflowBlock: warsApp.models.IWorkflowBlock,
            pendingBlocks: models.PendingWorkflowItem[],
            workflowItemsAwaitingDrawing: models.WorkflowItemAwaitingDrawing[])
        {
            return Enumerable.from(workflowDrawingInstance.blockLocations).any(i => i.workflowBlock.id === workflowBlock.id) ||
                Enumerable.from(pendingBlocks).any(i => i.pendingWorkflowBlock.id === workflowBlock.id) ||
                Enumerable.from(workflowItemsAwaitingDrawing).any(i => i.pendingWorkflowItem.pendingWorkflowBlock.id == workflowBlock.id);
        }
    }
}

warsApp.registerService('WorkflowDrawingService', []);